import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';
import React from 'react';

type MethodCardSkeletonProps = {
  className?: string;
};

type MethodCardsSkeletonProps = {
  count?: number;
};

export const MethodCardSkeleton: React.FC<MethodCardSkeletonProps> = ({ className }) => (
  <article className={cn('w-full animate-pulse rounded bg-[#333F57] px-1.5 py-1.5 sm:px-2.5', className)}>
    <div className="flex w-full p-2">
      <div className="flex flex-1 flex-col items-start space-y-2">
        <Skeleton className="h-6 w-3/4 rounded" />
        <Skeleton className="h-4 w-1/2 rounded" />
      </div>
      <div className="flex h-full items-center justify-end p-2">
        <Skeleton className="h-5 w-5 rounded" />
      </div>
    </div>
    <div className="my-1 h-[1px] w-full rounded bg-[var(--colors-dark-100)]" />
    <div className="flex w-full justify-center p-1">
      <Skeleton className="h-4 w-1/4 rounded" />
    </div>
  </article>
);

export const MethodCardsSkeleton: React.FC<MethodCardsSkeletonProps> = ({ count = 6 }) => (
  <div className="space-y-2 py-2 animate-in fade-in sm:space-y-4 sm:py-4">
    <div className="flex flex-col space-y-2 text-center vt-text-size-medium vt-headings-text">
      <Skeleton className="mx-auto h-6 w-32 rounded" />
    </div>
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, idx) => (
        <MethodCardSkeleton key={idx} />
      ))}
    </div>
  </div>
);
